import { DEFAULT_STORAGE_NAMES } from "@klw/localstorage";

const STORAGE_NAMES = {
  ...DEFAULT_STORAGE_NAMES,
};

export default STORAGE_NAMES;
